import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "studio-container" };
const _hoisted_2 = {
    key: 0,
    class: "studio-loading-overlay d-flex flex-column align-items-center justify-content-center"
};
const _hoisted_3 = { class: "studio-header shadow-sm bg-white px-4 d-flex justify-content-between align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = { class: "badge bg-success-subtle text-success smaller px-2" };
const _hoisted_6 = { class: "ms-5 btn-group btn-group-sm rounded-pill overflow-hidden border shadow-sm" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "d-flex align-items-center gap-3" };
const _hoisted_9 = {
    key: 0,
    class: "status-indicator d-flex align-items-center text-muted small me-2"
};
const _hoisted_10 = {
    key: 1,
    class: "status-indicator d-flex align-items-center text-success small me-2"
};
const _hoisted_11 = ["disabled"];
const _hoisted_12 = { class: "studio-main d-flex overflow-hidden" };
const _hoisted_13 = { class: "studio-sidebar bg-white border-end shadow-sm d-flex flex-column" };
const _hoisted_14 = { class: "sidebar-content flex-grow-1 overflow-auto p-3" };
const _hoisted_15 = { class: "section-card mb-4 border rounded-3 p-3 bg-light-subtle" };
const _hoisted_16 = {
    class: "accordion accordion-flush custom-accordion",
    id: "sectionsAccordion"
};
const _hoisted_17 = { class: "accordion-header" };
const _hoisted_18 = ["data-bs-target"];
const _hoisted_19 = ["id"];
const _hoisted_20 = {
    key: 0,
    class: "accordion-body p-4 bg-white"
};
const _hoisted_21 = { class: "mb-3" };
const _hoisted_22 = ["onUpdate:modelValue"];
const _hoisted_23 = { class: "mb-3" };
const _hoisted_24 = ["onUpdate:modelValue"];
const _hoisted_25 = { class: "mb-0" };
const _hoisted_26 = {
    class: "image-uploader position-relative border-2 border-dashed rounded-4 p-2 bg-light d-flex align-items-center justify-content-center overflow-hidden",
    style: { "height": "180px" }
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
    key: 1,
    class: "text-center text-muted p-4"
};
const _hoisted_29 = { class: "overlay-controls position-absolute inset-0 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100 transition" };
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
    key: 0,
    class: "mt-2 text-end"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = { class: "studio-preview flex-grow-1 bg-gray-200 d-flex flex-column overflow-hidden" };
const _hoisted_34 = { class: "preview-header py-2 d-flex justify-content-center align-items-center bg-white border-bottom gap-2" };
const _hoisted_35 = { class: "btn-group btn-group-sm rounded-pill overflow-hidden border" };
const _hoisted_36 = { class: "d-flex align-items-center ms-3 text-muted small" };
const _hoisted_37 = { class: "preview-canvas flex-grow-1 p-4 d-flex justify-content-center overflow-auto bg-body-tertiary" };
const _hoisted_38 = ["src"];
const _hoisted_39 = {
    key: 0,
    class: "sync-overlay position-absolute bottom-0 end-0 m-4 p-2 bg-dark text-white rounded-pill shadow-lg d-flex align-items-center px-3",
    style: { "font-size": "11px", "z-index": "10" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("div", {
                        class: "spinner-border text-primary mb-3",
                        style: { "width": "3rem", "height": "3rem" },
                        role: "status"
                    }, null, -1),
                    _createElementVNode("h4", { class: "fw-bold text-dark" }, "Chargement du Studio...", -1),
                    _createElementVNode("p", { class: "text-muted" }, "Préparation de vos outils de design", -1)
                ]))]))
            : _createCommentVNode("", true),
        (!_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("header", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                            class: "btn btn-light rounded-circle me-3",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.handleExit && _ctx.handleExit(...args))),
                            title: "Quitter le Studio"
                        }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "ri-close-line fs-5" }, null, -1)
                            ]))]),
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "header-divider me-3" }, null, -1)),
                        _createElementVNode("div", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "h6 mb-0 fw-bold text-dark" }, "Va Bene Design Studio", -1)),
                            _createElementVNode("span", _hoisted_5, "Modèle: " + _toDisplayString(_ctx.pageConfig.label), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['fr', 'en', 'de', 'it'], (lang) => {
                                return _createElementVNode("button", {
                                    key: lang,
                                    class: _normalizeClass(["btn py-1 px-3 fw-bold", _ctx.activeLocale === lang ? 'btn-dark' : 'btn-white']),
                                    onClick: ($event) => (_ctx.activeLocale = lang)
                                }, _toDisplayString(lang.toUpperCase()), 11, _hoisted_7);
                            }), 64))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        (_ctx.saving)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[11] || (_cache[11] = [
                                    _createElementVNode("div", {
                                        class: "spinner-border spinner-border-sm me-2 text-primary",
                                        role: "status"
                                    }, null, -1),
                                    _createTextVNode(" Sauvegarde... ", -1)
                                ]))]))
                            : (_ctx.lastSaved)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[12] || (_cache[12] = [
                                        _createElementVNode("i", { class: "ri-checkbox-circle-line me-1" }, null, -1),
                                        _createTextVNode(" Publié ", -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                        _createElementVNode("button", {
                            class: "btn btn-success px-4 rounded-pill fw-bold shadow-sm",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.savePage && _ctx.savePage(...args))),
                            disabled: _ctx.saving
                        }, [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("i", { class: "ri-send-plane-fill me-1" }, null, -1),
                                _createTextVNode(" Publier les modifications ", -1)
                            ]))], 8, _hoisted_11)
                    ])
                ]),
                _createElementVNode("main", _hoisted_12, [
                    _createElementVNode("aside", _hoisted_13, [
                        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "sidebar-header p-4 border-bottom" }, [
                            _createElementVNode("h2", { class: "h6 fw-bold mb-1 text-uppercase text-muted letter-spacing-1" }, "Sections de la page"),
                            _createElementVNode("p", { class: "small text-muted mb-0" }, "Modifier les blocs de contenu")
                        ], -1)),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label small fw-bold text-muted text-uppercase mb-2" }, "Titre Global de la Page", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.sectionData.title) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.sectionData.title]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageConfig.sections, (section, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: key,
                                        class: "accordion-item border rounded-3 mb-3 overflow-hidden shadow-sm"
                                    }, [
                                        _createElementVNode("h2", _hoisted_17, [
                                            _createElementVNode("button", {
                                                class: "accordion-button collapsed py-3 px-4 fw-bold",
                                                type: "button",
                                                "data-bs-toggle": "collapse",
                                                "data-bs-target": '#collapse-' + key
                                            }, [
                                                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "ri-layout-masonry-line me-2 text-primary" }, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(section.label), 1)
                                            ], 8, _hoisted_18)
                                        ]),
                                        _createElementVNode("div", {
                                            id: 'collapse-' + key,
                                            class: "accordion-collapse collapse",
                                            "data-bs-parent": "#sectionsAccordion"
                                        }, [
                                            (_ctx.sectionData.sections[key])
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label small fw-bold text-muted text-uppercase" }, "Titre du bloc", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            class: "form-control",
                                                            "onUpdate:modelValue": ($event) => ((_ctx.sectionData.sections[key].title) = $event),
                                                            placeholder: "Texte par défaut..."
                                                        }, null, 8, _hoisted_22), [
                                                            [_vModelText, _ctx.sectionData.sections[key].title]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label small fw-bold text-muted text-uppercase" }, "Description", -1)),
                                                        _withDirectives(_createElementVNode("textarea", {
                                                            class: "form-control",
                                                            rows: "5",
                                                            "onUpdate:modelValue": ($event) => ((_ctx.sectionData.sections[key].description) = $event),
                                                            placeholder: "Description par défaut..."
                                                        }, null, 8, _hoisted_24), [
                                                            [_vModelText, _ctx.sectionData.sections[key].description]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label small fw-bold text-muted text-uppercase mb-2" }, "Image du bloc", -1)),
                                                        _createElementVNode("div", _hoisted_26, [
                                                            (_ctx.sectionData.sections[key].image)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: _ctx.sectionData.sections[key].image,
                                                                    class: "w-100 h-100 object-cover"
                                                                }, null, 8, _hoisted_27))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[18] || (_cache[18] = [
                                                                        _createElementVNode("i", { class: "ri-image-add-line fs-1 d-block mb-2" }, null, -1),
                                                                        _createElementVNode("span", { class: "small fw-bold" }, "Ajouter une image", -1)
                                                                    ]))])),
                                                            _createElementVNode("div", _hoisted_29, [
                                                                _createElementVNode("button", {
                                                                    class: "btn btn-dark btn-sm rounded-pill px-3 shadow-sm",
                                                                    onClick: ($event) => (_ctx.pickSectionImage(key))
                                                                }, [...(_cache[19] || (_cache[19] = [
                                                                        _createElementVNode("i", { class: "ri-upload-2-line me-1" }, null, -1),
                                                                        _createTextVNode(" Changer ", -1)
                                                                    ]))], 8, _hoisted_30)
                                                            ])
                                                        ]),
                                                        (_ctx.sectionData.sections[key].image)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                                _createElementVNode("button", {
                                                                    class: "btn btn-link btn-sm p-0 text-decoration-none d-inline-flex align-items-center text-primary fw-medium",
                                                                    onClick: ($event) => (_ctx.syncImageToAllLocales(key)),
                                                                    title: "Copier cette image dans toutes les autres langues"
                                                                }, [...(_cache[20] || (_cache[20] = [
                                                                        _createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1),
                                                                        _createTextVNode(" Appliquer à toutes les langues ", -1)
                                                                    ]))], 8, _hoisted_32)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ], 8, _hoisted_19)
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"sidebar-footer p-4 border-top bg-light-subtle\" data-v-38dfa3c2><div class=\"alert alert-info py-2 px-3 mb-0 border-0 rounded-3 shadow-sm\" data-v-38dfa3c2><div class=\"d-flex align-items-center\" data-v-38dfa3c2><i class=\"ri-information-fill me-2 fs-5\" data-v-38dfa3c2></i><div class=\"small fw-bold\" data-v-38dfa3c2>Vos modifications sont enregistrées en local. N&#39;oubliez pas de <strong data-v-38dfa3c2>Publier</strong>.</div></div></div></div>", 1))
                    ]),
                    _createElementVNode("section", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["btn py-1 px-3", _ctx.previewSize === 'mobile' ? 'btn-dark' : 'btn-white']),
                                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.previewSize = 'mobile'))
                                }, [...(_cache[24] || (_cache[24] = [
                                        _createElementVNode("i", { class: "ri-smartphone-line" }, null, -1)
                                    ]))], 2),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["btn py-1 px-3", _ctx.previewSize === 'tablet' ? 'btn-dark' : 'btn-white']),
                                    onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.previewSize = 'tablet'))
                                }, [...(_cache[25] || (_cache[25] = [
                                        _createElementVNode("i", { class: "ri-tablet-line" }, null, -1)
                                    ]))], 2),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["btn py-1 px-3", _ctx.previewSize === 'desktop' ? 'btn-dark' : 'btn-white']),
                                    onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.previewSize = 'desktop'))
                                }, [...(_cache[26] || (_cache[26] = [
                                        _createElementVNode("i", { class: "ri-computer-line" }, null, -1)
                                    ]))], 2)
                            ]),
                            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "ms-3 header-divider" }, null, -1)),
                            _createElementVNode("div", _hoisted_36, [
                                _cache[27] || (_cache[27] = _createElementVNode("i", { class: "ri-links-line me-1" }, null, -1)),
                                _createElementVNode("code", null, "/" + _toDisplayString(_ctx.activeLocale) + _toDisplayString(_ctx.pageConfig.previewPath) + "?preview=true", 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", {
                                class: "preview-frame shadow-2xl bg-white position-relative",
                                style: _normalizeStyle({
                                    width: _ctx.previewWidth,
                                    height: '100%',
                                    transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)'
                                })
                            }, [
                                _createElementVNode("iframe", {
                                    ref: "previewIframe",
                                    src: _ctx.previewUrl,
                                    class: "w-100 h-100 border-0",
                                    onLoad: _cache[6] || (_cache[6] =
                                        //@ts-ignore
                                        (...args) => (_ctx.onPreviewLoaded && _ctx.onPreviewLoaded(...args)))
                                }, null, 40, _hoisted_38),
                                (_ctx.syncing)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [...(_cache[29] || (_cache[29] = [
                                            _createElementVNode("div", {
                                                class: "spinner-border spinner-border-sm me-2 text-success",
                                                style: { "width": "12px", "height": "12px" }
                                            }, null, -1),
                                            _createTextVNode(" SYNCHRONISATION... ", -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ], 4)
                        ])
                    ])
                ])
            ], 64))
            : _createCommentVNode("", true)
    ]));
}
